import { RadialProgress } from './RadialProgress';
import { SegmentChart } from './SegmentChart';

export const Chart = { RadialProgress, SegmentChart };
